import _ from 'underscore';
import { useSelector } from 'react-redux';
import type { RootState } from '../../../store/models';
import type { DiscountDetails } from '../../../store/NCDAndDiscountedPros.types';

export default function useDiscountDetails():
DiscountDetails {
  return useSelector((state: RootState) => ({
    discountCode: state.ncdAndDiscountedPros.discountCode,
    discountAmount: state.ncdAndDiscountedPros.discountAmount,
    discountPercent: state.ncdAndDiscountedPros.discountPercent,
    discountMax: state.ncdAndDiscountedPros.discountMax,
  }), _.isEqual);
}
